import { useCallback } from 'react';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { useAppSelector } from 'js/store/hooks';
import { getTwoFactorConf } from 'js/hooks/user/server';
import { useGetPlayerTags } from 'server';

const getPlayerChannel = async (getPlayerTags) => {
    const { tags: [tag] = [] } = await getPlayerTags({ tagName: 'uam/2fa/2FAChannel' });

    return tag?.value?.toLowerCase();
};

const getDefaultChannel = async (casinoName) => {
    const response = await getTwoFactorConf({ casinoName });

    return response?.data?.twoFactorConf?.defaultChannel?.toLowerCase();
};

export const useGetTitleAsync = () => {
    const t = useTranslations('playtech.mobile.system.2FA.popup.');
    const casinoName = useAppSelector(prop('casinoName'));
    const getPlayerTags = useGetPlayerTags();

    return useCallback(async () => {
        try {
            switch (await getPlayerChannel(getPlayerTags)) {
                case 'sms': return t('title.SMS');
                case 'email': return t('title.email');
                default: break;
            }

            switch (await getDefaultChannel(casinoName)) {
                case 'sms': return t('title.SMS');
                case 'email': return t('title.email');
                default: break;
            }

            return t('title.default');
        } catch (error) {
            return t('title.default');
        }
    }, [casinoName, t, getPlayerTags]);
};
